import { Component, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

export type TooltipPosition = 'above' | 'below' | 'left' | 'right' | 'dynamic';

@Component({
  selector: 'ni-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ni-tooltip.component.html',
})
export class NiTooltipComponent {
  position: TooltipPosition = 'dynamic';
  theme: 'light' | 'dark' = 'dark';
  content = '';
  tooltipTemplate: TemplateRef<any> | null = null;
  left = 0;
  top = 0;
  visible = false;

  @Input() set tooltip(value: string) {
    this.content = value;
  }
}